import React, { useState, useMemo, useContext, useEffect } from "react";
import {  Col, Container, Row, Card, CardBody } from "reactstrap";
import { useQuery } from "react-query";
import { Modal, Skeleton, Spin } from "antd";
import '../utils/style.css';
import { getAllMerchent } from "../../merchant/services/merchentApi.js";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import trier from "../../../../assets/images/mdi_sort.png";
import defaultAvatar from "../../../../assets/images/image business défaut.png";
import vectorIcon from "../../../../assets/images/menu-alt-2.png";
import empty from "../../../../assets/images/emptyBusiness.png";
import { useNavigate } from "react-router-dom";
import TableContainerMin from "../../../../common/TableContainerMin.js";
import { getManageByMarchand, getManagePayIn, getTransactionByMarchand } from "../services/homeAdminApi.js";
import parsePhoneNumberFromString from "libphonenumber-js";
import DetailManage from "./detailManage.js";

const ManagePayIn = ({ selectedMarchand,title,data}) => {
    const navigate = useNavigate();
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  document.title = `Business | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [modalState, setModalState] = useState({ type: null, data: null });
  const [sortOrder, setSortOrder] = useState("asc");
const { data: manages, isLoading, isError } = useQuery(
  ["manages", selectedMarchand],
  async () => {
    let response;

    if (selectedMarchand) {
      response = await getTransactionByMarchand(selectedMarchand);
    } else {
      response = await getManagePayIn();
    }
    return (response.data ?? []).map((item) => ({
      id: item.transactionReference,
      developerAccountName: item.developerAccountName,
      merchantAccountName: item.merchantAccountName,
      businessName: item.developerAccountName,
      country: item.countryCode,
      amount: Number(item.amount),
      realAmount: Number(item.realAmount),
      createdAt: item.createdAt,
      status: item.status,
      logo: item.logo ?? item.image ?? defaultAvatar,
      clientNumber: item.clientNumber,
      currency: item.currency,
      transactionReference:item.transactionReference,
      paymentMethodName:item.paymentMethodName

    }));
  }
);
  const {  } = useQuery("merchents", getAllMerchent);
 const [searchTerm, setSearchTerm] = useState("");
const [filterValues, setFilterValues] = useState(null);
const filteredManages = useMemo(() => {
  if (!manages || manages.length === 0) return [];
  let result = [...manages];
  if (searchTerm) {
    const lowerSearch = searchTerm.toLowerCase();
  result = result.filter(dev =>
  ( dev.developerAccountName )?.toLowerCase().includes(lowerSearch) ||
  (dev.merchantAccountName  ?? "")?.toLowerCase().includes(lowerSearch) 
);
  }
  if (sortOrder === "asc") {
            result.sort((a, b) => new Date(a.requestDate) - new Date(b.requestDate));
          } else {
            result.sort((a, b) => new Date(b.requestDate) - new Date(a.requestDate));
          }

  return result;
}, [manages,searchTerm,filterValues,sortOrder]);
  const openModal = (type, data = null) => {
    setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
  };

  const handleEdit = (developer) => {
    openModal("edit", developer);
  };

  const handleDetail = (developer) => {
    navigate(`/business-management/${developer.id}`);
  };
  const handleValidate = (developer) => {
    openModal("valid", developer);
  };
  const openDeleteConfirmModal = (developerId) => {
    const developerToDelete = manages.find(developer => developer.id === developerId);
    if (developerToDelete) {
      setModalState({
        type: "delete",
        data: { developerId, developerName: developerToDelete.businessName },
      });
    }
  };
   const countries = useMemo(() => {
    const allCountries = filteredManages.map(t => t.country).filter(Boolean);
    return [...new Set(allCountries)];
  }, [filteredManages]);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const columns = useMemo(() => [
{
  Header: "Nom Business",
  accessor: "developerAccountName",
  filterable: false,
  Cell: ({ row }) => {
    const { developerAccountName, logo } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span>
        <img
          src={logo || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        </span>
        <span>{developerAccountName}</span>
        </div>
      );
    }
    },
    {
   Header: "Compte",
    accessor: "clientNumber",
  Cell: ({ value }) => {
  if (!value) return "-"; 
  try {
    const phone = parsePhoneNumberFromString(String(value));
    return phone ? phone.formatInternational() : value;
  } catch (e) {
    return value;
  }
},
          filterable: false,
        },
{
  Header: "Montant débité",
  accessor: "amount",
  filterable: false,
  Cell: ({ value, row }) => {
    const amount = value ?? 0;
    const currency = row.original.currency ?? "XOF";

    return (
      <span style={{ fontWeight: 600 }}>
        {amount.toLocaleString("fr-FR")} {currency}
      </span>
    );
  },
},
{
  Header: "Montant reçu",
  accessor: "realAmount",
  filterable: false,
  Cell: ({ value, row }) => {
    const amount = value ?? 0;
    const currency = row.original.currency ?? "XOF";

    return (
      <span style={{ fontWeight: 600 }}>
        {amount.toLocaleString("fr-FR")} {currency}
      </span>
    );
  },
},
 {
        Header: "Date de paiement",
        accessor: "createdAt",
        Cell: ({ value }) =>
          value
      ? new Date(value).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-",
    filterable: false,
    },
{
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => {
      let label = "Échec";
      let style = {
        backgroundColor: " #FFF0F0",
        color: " #D41C1C",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === "SUCCESS") {
        label = "Réussie";
         icon = "✓";
        style.backgroundColor = "#EBFFEA";
        style.color = "#349C32";          
      } else if (value === "PENDING") {
        label = "En attente";
         icon = "⏳";
         style.backgroundColor = "#FFEFD5";
        style.color = "#FF9F00";  
      }
      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    },  
    {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width:"80px",
                fontFamily:'Poppins',
                fontSize:'13px',
                backgroundColor: "#F2F5FF",
                cursor: "pointer",
                border: "1px solid #00000014",
                color:'#3761FF'
              }}
            onClick={(e) => {
          e.stopPropagation();
          setSelectedBusiness(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true); 
        }}
            >
             consulter
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ], [handleEdit, openDeleteConfirmModal, handleDetail, handleValidate]);
  const HeaderTable = () => (
    <div className="d-flex flex-column align-items-start gap-3 w-100">
      <div className=' mb-2'style={{color:"#444444",fontFamily:"Poppins",fontSize:"15px",fontWeight:'500'}}>
        {title}
        <span className="lenght">
      {isLoading ? (
        <Spin size="small" />
      ) : !manages?.length ? (
        "0"
      ) : (
        manages.length
      )}
    </span>
        </div>

</div>
      );
  return (
    <React.Fragment>
      <Card className="h-100 w-100" style={{ borderRadius: "10px",background:"#FFFFFF",border:'none' }}>
      <div className="page-content">
        <Container fluid>
          <HeaderTable />
              <div className="header-actions w-100 mb-2">
   
            <div className="col-6">
              <input
                type="text"
                placeholder="Rechercher une transaction d'un business..."
                className="form-control search"
                 value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
              <>
          </>
        </div>
          <Row>
            <Col>
             <Card className="h-100 w-100"style={{ borderRadius: "10px",background:"#FFFFFF",border:'none' }} >
                <CardBody className="p-0 ">
                  {isLoading ? (
                <div style={{ padding: "20px" }}>
                  <Skeleton active paragraph={{ rows: 8 }} />
                </div>
              ) : (
                <TableContainerMin
                  columns={columns}
                  data={filteredManages}
                  isGlobalFilter={false}
                  customPageSize={10}
                  className="custom-header-css"
                  divClass="table-responsive"
                  tableClass="table w-100 mb-0 no-column-borders"
                  theadClass="custom-thead"
                  SearchPlaceholder="Recherche..."
                  HeaderTable={HeaderTable}
                />
              )}
                  {isLoading && !isError && (
                    <div className="text-center">
                     <Skeleton />
                    </div>
                  )}
                  {filteredManages && filteredManages.length === 0 && !isLoading && (
                  <div style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "40px 0"
                    }}
                  >
                  <img
                  src={empty} 
                  alt="Liste vide"
                  style={{ width: "150px" }}
                /></div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        <DetailManage
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        selectedBusiness={selectedBusiness}
      />        
        </Container>
      </div>
      </Card>
    </React.Fragment>
  );
};

export default ManagePayIn;
